(() => {
  if (customElements.get('ho-email-offer')) return;
  customElements.define('ho-email-offer', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = 'ho-email-offer:' + this.dataset.campaign;
      this.preview = this.dataset.preview === 'true';
      const form = this.querySelector('form');
      const updateReturnPath = () => {
        const returnInput = form?.querySelector('input[name="return_to"]');
        if (!returnInput) return;
        const returnUrl = new URL(location.href);
        returnUrl.searchParams.set('customer_posted', 'true');
        returnInput.value = returnUrl.pathname + returnUrl.search + '#' + form.id;
      };
      updateReturnPath();
      const returnedToThisForm = location.hash === '#' + this.querySelector('form')?.id;
      this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.querySelector('[data-offer-open]')?.addEventListener('click', () => this.open(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        if (!this.preview) { try { localStorage.setItem(this.key, 'dismissed'); } catch (_) { /* Storage may be unavailable. */ } }
        this.previousFocus?.focus?.();
      }, options);
      this.querySelector('form')?.addEventListener('submit', event => {
        if (this.preview) { event.preventDefault(); return; }
        try { sessionStorage.removeItem('ho-newsletter-signup-tracked'); } catch (_) {}
        // Read at submission too: product options can update the current URL.
        updateReturnPath();
      }, options);
      if (this.dataset.result && !returnedToThisForm) return;
      if (this.dataset.result === 'success') {
        const reportSignup = () => {
          if (this.preview) return;
          try { if (sessionStorage.getItem('ho-newsletter-signup-tracked')) return; } catch (_) {}
          if (window.HearthOutpostAnalytics?.track('newsletter_signup', { interaction_area: 'newsletter' })) {
            try { sessionStorage.setItem('ho-newsletter-signup-tracked', 'true'); } catch (_) {}
          }
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reportSignup, { once: true }); else reportSignup();
        try { localStorage.setItem(this.key, 'subscribed'); } catch (_) { /* Keep signup usable without storage. */ }
      }
      if (this.dataset.result) { this.open(); return; }
      let dismissed = false;
      try { dismissed = Boolean(localStorage.getItem(this.key)); } catch (_) { /* Session-only behavior. */ }
      if (this.preview || (!dismissed && this.dataset.subscribed !== 'true')) {
        this.timer = setTimeout(() => this.openWhenAvailable(), Number(this.dataset.delay) * 1000);
      }
    }
    openWhenAvailable() {
      if (document.hidden || document.querySelector('dialog[open]')) {
        this.timer = setTimeout(() => this.openWhenAvailable(), 1000);
        return;
      }
      this.open();
    }
    open() {
      if (!this.dialog.isConnected || this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.querySelector('[data-offer-close]').focus();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow;
      }
      this.abort?.abort();
    }
  });
})();
